<template>
  <div class="row">
    <div class="col-12">
      <q-markup-table flat dense square bordered separator="cell">
        <template>
          <thead>
            <tr>
              <th>#</th>
              <th>{{ $ts('table.th.sku') }}</th>
              <th>{{ $ts('table.th.name') }}</th>
              <th>{{ $ts('table.th.maxQty') }}</th>
              <th>{{ $ts('table.th.unitPrice') }}</th>
              <th>{{ $ts('tables.th.unitPoint') }}</th>
              <th class="bg-amber-1">{{ $ts('tables.th.totalUnitPoint') }}</th>
              <th>{{ $ts('table.th.actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in getItems">
              <td>
                {{ index + 1 }}
              </td>
              <td>{{ item.sku }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.max_quantity }}</td>
              <td v-if="!item.is_foc">{{ currencyLabelByCountry }} {{ item.price | formatPriceDouble }}</td>
              <td v-else class="text-positive">{{ $ts('words.free') }}</td>
              <td>{{ item.unit_point }}</td>
              <td class="bg-amber-1">{{ (item.unit_point || 0) * getSelectedCampaignItems(item).quantity }}</td>
              <td align="center">
                <q-btn-group v-if="!readOnly && item.redeemable" rounded unelevated>
                  <q-btn
                    unelevated
                    rounded
                    size="sm"
                    icon="add"
                    color="positive"
                    :disable="
                      readOnly ||
                        getSelectedCampaignItems(item).quantity === getSelectedCampaignItems(item).max_quantity ||
                        !item.selectable
                    "
                    :label="
                      `( ${getSelectedCampaignItems(item).quantity} / ${getSelectedCampaignItems(item).max_quantity} )`
                    "
                    @click="rowAddCallback(item)"
                  ></q-btn>
                  <q-btn
                    unelevated
                    rounded
                    size="sm"
                    icon="remove"
                    color="negative"
                    :disable="getSelectedCampaignItems(item).quantity <= 0"
                    @click="rowRemoveCallback(item)"
                  ></q-btn>
                </q-btn-group>
                <span v-else>
                  {{
                    !readOnly && !item.redeemable
                      ? `Insufficient point`
                      : `( ${getSelectedCampaignItems(item).quantity} ) Selected`
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <td colspan="6"></td>
              <td class="bg-amber-1 text-bold">{{ getTotalSelectedVoucherPoint }} / ({{ eligibleVoucherPoint }})</td>
              <td></td>
            </tr>
            <tr v-if="!items.length">
              <td colspan="9">
                <empty-list />
              </td>
            </tr>
          </tbody>
        </template>
      </q-markup-table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProductsTableMinimal',
  props: {
    selectedItems: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    eligibleVoucherPoint: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters(['currencyLabelByCountry']),
    getItems() {
      return this.items.map(item => {
        let availablePoint = this.eligibleVoucherPoint - this.getTotalSelectedVoucherPoint
        let itemUnitPoint = item.unit_point
        return {
          selectable: itemUnitPoint <= availablePoint,
          ...item,
        }
      })
    },
    getTotalSelectedVoucherPoint() {
      return _.sumBy(this.selectedItems, function(item) {
        return item.unit_point * item.quantity
      })
    },
  },
  methods: {
    getSelectedCampaignItems(row) {
      let { type, id } = row
      let item =
        this.selectedItems.find(x => x.id === id && x.type === type) ||
        this.items.find(x => x.id === id && x.type === type)
      return {
        quantity: 0,
        max_quantity: 0,
        is_foc: false,
        ...item,
      }
    },
    rowAddCallback(row) {
      this.$emit('rowAddCallback', row)
    },
    rowRemoveCallback(row) {
      this.$emit('rowRemoveCallback', row)
    },
  },
}
</script>
